import clone from 'ramda/src/clone';
import isNil from 'ramda/src/isNil';
import pathOr from 'ramda/src/pathOr';
import reject from 'ramda/src/reject';
import { FeatureToggleConstants, i18n, MetadataActions, MetadataConstants, MetadataSelectors, SessionSelectors, UnsavedChangesPromptActions } from 'invision-core';
import { FeatureTogglesSelector } from 'invision-core/src/components/featureToggle/featureToggle.selectors';
import { getFilterService } from 'invision-core/src/components/injectables/injector.helper';
import LocaleKeys from '../../../locales/keys';
import { chargePaymentInstrument, clearSelectedPaymentMethod, resetIsMakingPayment, retrieveAvailablePaymentInstrumentTypes, editPaymentInstrument, selectPaymentMethod, updatePaymentAccountsOnSelectedPaymentMethod, retrieveWallet } from '../../../reducers/actions/customer.ewallet.actions';
import { DefaultPaymentMethodSelector, EwalletErrorSelector, PaymentInstrumentSummariesSelector, PaymentInstrumentsCanBeUsedForOrderingWithTypeNamesViewModelSelector, PaymentIsCreatingOrEditingDataSelector, PaymentIsUpdatingAutoPaySelector, IsMakingPaymentSelector, IsRetrievingEwalletDataSelector, SelectedPaymentMethodConvergentBillerPaymentInstrumentAccountsSelector, SelectedPaymentMethodSelector, SelectedPaymentForSubmitAtCheckoutSelector } from '../../../reducers/selectors/customer.ewallet.selectors';
import { DefaultBillingAddressSelector } from '../../../reducers/selectors/customer.addresses.selectors';
import { CurrentCustomerAccountingMethodSelector, CurrentCustomerIdSelector, RouteParams } from '../../../reducers/selectors/customer.selectors';
import { ACCOUNTING_METHODS_NAMES, BILLPAY_OPTIONS, MAKE_PAYMENT_ROUTE, MAKE_PAYMENT_TYPES } from './make.payment.constants';
import { retrieveConvergentBillerSubscriberSummary, retrieveConvergentBillerTreatmentDetails } from '../../../reducers/actions/customer.convergent.biller.actions';
import { ConvergentBillerIsInPromiseToPay, ConvergentBillerIsInTreatment, ConvergentBillerCurrentPromiseToPayInstallment, ConvergentBillerSubscriberSummarySelector, ConvergentBillerSubscriberSummaryAccountsSelector, ConvergentBillerSubscriberSummaryPostPaidAccountSelector, ConvergentBillerSubscriberSummaryPrePaidAccountSelector, ConvergentBillerTreatmentDetailsSelector, CurrentAccountSummarySelector, CurrentPostPaidAccountSummarySelector, CurrentPostPaidAccountSummaryTotalSelector, IsFetchingSubscriberSummarySelector, IsARCSubscriptionMgmtFeatureToggleSelector } from '../../../reducers/selectors/customer.convergent.biller.selectors';
import { TREATMENT_STATUS } from '../../../reducers/constants/convergent.biller.constants';
import { NOTIFICATION_TIME_LENGTH } from '../../../customercare.constants';
import { stateGo } from 'redux-ui-router';
import { retrieveCustomerHouseholds } from '../../../reducers/actions/customer.household.actions';
import { CurrentHouseholdSelector, CurrentMemberHasCreatePaymentInstrumentPermissionsSelector } from '../../../reducers/selectors/customer.household.selectors';
import { DeviceFinancingNameSelector, SubscriberDeviceFinancingDetailsSelector, SubscriberDeviceFinancingWidgetActiveDeviceDetailsSelector } from '../../../reducers/selectors/customer.devices.selectors';
import { retrieveSubscriberFinanceDetails, setDeviceFinancingWidgetSelectedDevice } from '../../../reducers/actions/customer.devices.actions';
import { deviceFinancingFriendlyName } from '../dashboard/dbssDashboard/deviceFinancing/device.financing.helper';
import { InvoiceSummariesSelector } from '../../../reducers/selectors/customer.billing.selectors';
import { INVOICES } from '../../billingPayments/billing.payments.constants';
import { retrieveLedgerSummary } from '../../../reducers/actions/customer.billing.actions';
import { convertStringToNumber } from 'invision-core/src/components/helpers/conversion.helper';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
function CustomerMakePaymentController($ngRedux, uiNotificationService, $timeout, $state) {
  var _this = this;
  var disconnectRedux;
  var previouslySelectedAccount = {};
  var previousAutoPayPaymentInstrument = {};
  this.hasDeviceFinancingLoaded = false;
  this.deviceFinancingAccountDisplayName = '';
  var mapStateToTarget = function mapStateToTarget(store) {
    return {
      billingAddress: DefaultBillingAddressSelector(store),
      featureTogglesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(CODES.FeatureToggleConfig, store),
      currentAccountSummary: CurrentAccountSummarySelector(store),
      currentCustomerAccountingMethod: CurrentCustomerAccountingMethodSelector(store),
      currentCustomerId: CurrentCustomerIdSelector(store),
      currentHousehold: CurrentHouseholdSelector(store),
      currentMemberCanCreatePaymentInstrument: CurrentMemberHasCreatePaymentInstrumentPermissionsSelector(store),
      currentPostPaidAccountSummary: CurrentPostPaidAccountSummarySelector(store),
      defaultPaymentMethod: DefaultPaymentMethodSelector(store),
      deviceFinancingName: DeviceFinancingNameSelector(store),
      eWalletError: EwalletErrorSelector(store),
      features: FeatureTogglesSelector(store),
      hasPromiseToPay: ConvergentBillerIsInPromiseToPay(store),
      invoiceList: InvoiceSummariesSelector(store),
      isARCSubscriptionMgmtFeatureLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.MicroserviceConfiguration, store),
      isARCSubscriptionMgmtFeatureToggle: IsARCSubscriptionMgmtFeatureToggleSelector(store),
      isCreatingOrEditingPaymentMethodData: PaymentIsCreatingOrEditingDataSelector(store),
      isFetchingEwalletData: IsRetrievingEwalletDataSelector(store),
      isFetchingSubscriberSummary: IsFetchingSubscriberSummarySelector(store),
      isInTreatment: ConvergentBillerIsInTreatment(store),
      isMakingPayment: IsMakingPaymentSelector(store),
      isUpdatingAutoPayData: PaymentIsUpdatingAutoPaySelector(store),
      paymentInstruments: PaymentInstrumentsCanBeUsedForOrderingWithTypeNamesViewModelSelector(store),
      paymentInstrumentSummaries: PaymentInstrumentSummariesSelector(store),
      periodTypesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.PeriodType, store),
      postPaidSubscriberSummaryAccounts: ConvergentBillerSubscriberSummaryPostPaidAccountSelector(store),
      prepaidSubscriberSummaryAccounts: ConvergentBillerSubscriberSummaryPrePaidAccountSelector(store),
      promiseToPayDetails: ConvergentBillerCurrentPromiseToPayInstallment(store),
      routeParams: RouteParams(store),
      selectedDeviceFinancing: SubscriberDeviceFinancingWidgetActiveDeviceDetailsSelector(store),
      selectedPaymentMethodPaymentAccountsSelector: SelectedPaymentMethodConvergentBillerPaymentInstrumentAccountsSelector(store),
      selectedPaymentMethod: SelectedPaymentMethodSelector(store),
      selectedPaymentClean: SelectedPaymentForSubmitAtCheckoutSelector(store),
      subscriberFinancingDevices: SubscriberDeviceFinancingDetailsSelector(store),
      subscriberSummary: ConvergentBillerSubscriberSummarySelector(store),
      subscriberSummaryAccounts: ConvergentBillerSubscriberSummaryAccountsSelector(store),
      totalBalance: CurrentPostPaidAccountSummaryTotalSelector(store),
      treatmentDetails: ConvergentBillerTreatmentDetailsSelector(store),
      lastRoute: SessionSelectors.LastRouteSelector(store)
    };
  };
  var controllerActions = {
    chargePaymentInstrument: chargePaymentInstrument,
    clearSelectedPaymentMethod: clearSelectedPaymentMethod,
    editPaymentInstrument: editPaymentInstrument,
    fetchCodeTypes: MetadataActions.codes.fetchCodeTypes,
    fetchPeriodTypes: MetadataActions.codes.fetchPeriodTypes,
    resetIsMakingPayment: resetIsMakingPayment,
    retrieveAvailablePaymentInstrumentTypes: retrieveAvailablePaymentInstrumentTypes,
    retrieveConvergentBillerSubscriberSummary: retrieveConvergentBillerSubscriberSummary,
    retrieveConvergentBillerTreatmentDetails: retrieveConvergentBillerTreatmentDetails,
    retrieveCustomerHouseholds: retrieveCustomerHouseholds,
    retrieveLedgerSummary: retrieveLedgerSummary,
    retrieveSubscriberFinanceDetails: retrieveSubscriberFinanceDetails,
    retrieveWallet: retrieveWallet,
    selectPaymentMethod: selectPaymentMethod,
    setDeviceFinancingWidgetSelectedDevice: setDeviceFinancingWidgetSelectedDevice,
    stateGo: stateGo,
    updatePaymentAccountsOnSelectedPaymentMethod: updatePaymentAccountsOnSelectedPaymentMethod,
    unregisterUnsavedChanges: UnsavedChangesPromptActions.unregisterUnsavedChanges
  };
  this.$onInit = function () {
    _this.LocaleKeys = LocaleKeys;
    _this.billPayOptions = BILLPAY_OPTIONS;
    _this.treatmentStatusTypes = TREATMENT_STATUS;
    _this.DEFAULT_BACK_ROUTE = 'index.customercare.customer.dashboard';
    _this.submitText = _this.isAutoPay ? LocaleKeys.AUTO_PAY.UPDATE : LocaleKeys.MAKE_PAYMENT.MAKE_PAYMENT;
    _this.isBalanceForward = false;
    _this.filter = getFilterService();
    _this.formattedInvoiceList = [];
    _this.selectedInvoiceNumber = null;
    _this.statementBalance = null;
    _this.statementBalanceDueDate = null;
    disconnectRedux = $ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
      _this.state = state;
      _this.actions = actions;
    });
    if (!_this.state.featureTogglesLoaded) {
      _this.actions.fetchCodeTypes(CODES.FeatureToggleConfig);
    }
    if (_this.deviceFinancingAccount) {
      _this.hasDeviceFinancingLoaded = !!_this.state.subscriberFinancingDevices.length;
      if (!_this.hasDeviceFinancingLoaded && !_this.state.features[FeatureToggleConstants.OFFCYCLE_BYPASS_ARM]) {
        _this.actions.retrieveSubscriberFinanceDetails(_this.state.currentCustomerId).then(function () {
          _this.hasDeviceFinancingLoaded = true;
          _this.getDeviceFinancingDetails();
        }).catch(function (error) {
          _this.hasDeviceFinancingLoaded = false;
          _this.uiNotificationService.transientError(error.translatedMessage);
        });
      } else {
        _this.hasDeviceFinancingLoaded = true;
        _this.getDeviceFinancingDetails();
      }
    }
    if (!_this.state.periodTypesLoaded) {
      _this.actions.fetchPeriodTypes();
    }
    if (!_this.state.isARCSubscriptionMgmtFeatureLoaded) {
      _this.actions.fetchCodeTypes(MetadataConstants.codes.MicroserviceConfiguration);
    }
    fetchRequiredData();
    _this.makePaymentStateOrName = MAKE_PAYMENT_ROUTE;
    _this.optionalParams = {
      customerId: _this.state.currentCustomerId
    };
    _this.mainFormServiceError = '';
    _this.changeAutoPayAccountNumberPopUp = {
      onRegisterApi: function onRegisterApi(evt) {
        _this.changeAutoPayAccountNumberPopUp = evt.api;
      }
    };
    _this.actions.retrieveAvailablePaymentInstrumentTypes().catch(function (error) {
      uiNotificationService.transientError(error.translatedMessage);
    });
    if (ACCOUNTING_METHODS_NAMES.BALANCE_FORWARD === _this.state.currentCustomerAccountingMethod) {
      _this.isBalanceForward = true;
    }
    _this.retrieveAllInvoices();
  };
  this.$onDestroy = function () {
    _this.actions.clearSelectedPaymentMethod();
    _this.actions.resetIsMakingPayment();
    disconnectRedux();
  };
  var fetchRequiredData = function fetchRequiredData() {
    if (!_this.state.treatmentDetails) {
      _this.actions.retrieveConvergentBillerTreatmentDetails(_this.state.currentCustomerId);
    }
    _this.actions.retrieveConvergentBillerSubscriberSummary(_this.state.currentCustomerId).then(function () {
      if (_this.isAutoPay) {
        _this.selectedAccount = _this.state.currentAccountSummary;
      } else if (_this.state.isARCSubscriptionMgmtFeatureToggle) {
        _this.selectedAccount = _this.state.currentAccountSummary;
        _this.paymentAmountOption = _this.getDefaultPaymentAmountOption();
      } else {
        _this.selectedAccount = _this.state.currentPostPaidAccountSummary;
        _this.paymentAmountOption = _this.getDefaultPaymentAmountOption();
      }
      _this.actions.retrieveWallet(_this.buildWalletRequest()).then(function () {
        if (_this.isAutoPay) {
          _this.initializeAutoPayFormFields();
        } else {
          _this.setCurrentlySelectedPaymentInstrument(_this.state.defaultPaymentMethod);
        }
      });
    });
    if (!_this.state.currentHousehold) {
      _this.actions.retrieveCustomerHouseholds(_this.state.currentCustomerId, false);
    }
  };

  // Determine which payment option is selected based on various criteria
  this.getDefaultPaymentAmountOption = function () {
    var paymentAmountOption;
    if (_this.shouldShowTreatmentAmounts()) {
      paymentAmountOption = _this.billPayOptions.INSTALLMENT_TOTAL;
    } else if (_this.shouldShowStatementBalance() && _this.getPaymentAmount(_this.billPayOptions.STATEMENT_BALANCE) > 0) {
      paymentAmountOption = _this.billPayOptions.STATEMENT_BALANCE;
    } else if (_this.showAccountTotal()) {
      paymentAmountOption = _this.billPayOptions.ACCOUNT_TOTAL;
    } else {
      paymentAmountOption = _this.billPayOptions.OTHER_AMOUNT;
    }
    return paymentAmountOption;
  };
  this.shouldShowTreatmentAmounts = function () {
    if (_this.state.subscriberSummary && _this.state.subscriberSummary.TreatmentStatus) {
      return _this.state.subscriberSummary.TreatmentStatus === _this.treatmentStatusTypes.IN_TREATMENT_WITH_P2P;
    }
    return false;
  };
  this.shouldShowStatementBalance = function () {
    if (_this.state.currentPostPaidAccountSummary && _this.state.currentPostPaidAccountSummary.PostpaidDetails && !_this.deviceFinancingAccount) {
      return !!_this.state.currentPostPaidAccountSummary.PostpaidDetails;
    }
    return false;
  };
  this.showAccountTotal = function () {
    return _this.state.isInTreatment && !_this.deviceFinancingAccount;
  };
  this.continueSettingAccountNumber = function (shouldSetAccountNumber) {
    if (shouldSetAccountNumber) {
      _this.actions.unregisterUnsavedChanges('CustomerMakePaymentController.formApi');
      _this.actions.stateGo('index.customercare.customer.autoPay', {
        accountNumber: _this.selectedAccount.AccountNumber
      }, {
        reload: false,
        notify: false,
        location: 'replace'
      });
      _this.initializeAutoPayFormFields();
    } else {
      _this.selectedAccount = previouslySelectedAccount;
    }
    _this.changeAutoPayAccountNumberPopUp.close();
  };
  this.shouldShowErrorForMainForm = function () {
    return _this.formApi.$submitted && (!_this.state.selectedPaymentMethod || !_this.selectedAccount && !_this.deviceFinancingAccount || _this.balanceIsInvalid() || _this.hasNoPaymentInstruments());
  };
  this.shouldShowErrorForMainFormField = function (fieldName) {
    return _this.formApi[fieldName] && (_this.formApi[fieldName].$touched || _this.formApi.$submitted) && _this.formApi[fieldName].$invalid;
  };
  this.shouldShowBalanceError = function () {
    return _this.paymentAmountOption === BILLPAY_OPTIONS.OTHER_AMOUNT && _this.balanceIsInvalid() && (_this.formApi.$submitted || _this.formApi.customPaymentAmount.$touched);
  };
  this.onAccountNumberChange = function (newAccount, previousAccount) {
    if (_this.isAutoPay) {
      previouslySelectedAccount = previousAccount;
      if (_this.isAutoPayChangedForAccount()) {
        _this.changeAutoPayAccountNumberPopUp.open();
      } else {
        _this.continueSettingAccountNumber(true);
      }
    }
  };
  this.initializeAutoPayFormFields = function () {
    if (_this.selectedAccount && _this.selectedAccount.AutoPayConfigured) {
      previousAutoPayPaymentInstrument = _this.state.paymentInstruments.find(function (pi) {
        if (pi.ConvergentBillerPaymentInstrumentAccounts && pi.ConvergentBillerPaymentInstrumentAccounts.length) {
          return pi.ConvergentBillerPaymentInstrumentAccounts.find(function (account) {
            return account.AutoPay && account.AccountNumber === _this.selectedAccount.AccountNumber;
          });
        }
      });
    } else {
      previousAutoPayPaymentInstrument = null;
    }
    _this.isAutoPayActivated = !!previousAutoPayPaymentInstrument;
    if (_this.isAutoPayActivated) {
      _this.setCurrentlySelectedPaymentInstrument(previousAutoPayPaymentInstrument);
    } else {
      _this.setCurrentlySelectedPaymentInstrument(_this.state.defaultPaymentMethod);
    }
  };
  this.getUpdatedPaymentAccountsForSelectedPaymentMethod = function () {
    if (_this.selectedAccount && _this.state.selectedPaymentMethod) {
      var paymentInstrumentPaymentAccounts = reject(function (currAccount) {
        return currAccount.AccountNumber === _this.selectedAccount.AccountNumber;
      }, _this.state.selectedPaymentMethodPaymentAccountsSelector);
      if (_this.isAutoPayActivated) {
        paymentInstrumentPaymentAccounts.push({
          AutoPay: _this.isAutoPayActivated,
          AccountNumber: _this.selectedAccount.AccountNumber
        });
      }
      return paymentInstrumentPaymentAccounts;
    }
    return [];
  };
  this.editAutoPayOnPaymentMethod = function () {
    if (_this.isAutoPay) {
      _this.actions.updatePaymentAccountsOnSelectedPaymentMethod({
        ConvergentBillerPaymentInstrumentAccounts: _this.getUpdatedPaymentAccountsForSelectedPaymentMethod()
      });
    }
  };
  this.isAutoPayChangedForAccount = function () {
    if (!previouslySelectedAccount) {
      return false;
    }
    if (previousAutoPayPaymentInstrument && _this.state.selectedPaymentMethod) {
      return !_this.isAutoPayActivated || previousAutoPayPaymentInstrument.Id !== _this.state.selectedPaymentMethod.Id;
    } else {
      return !!_this.isAutoPayActivated;
    }
  };
  this.setCurrentlySelectedPaymentInstrument = function (paymentInstrument) {
    _this.currentlySelectedPaymentInstrument = paymentInstrument;
    if (!isNil(paymentInstrument)) {
      _this.selectPaymentMethod();
    } else {
      _this.actions.clearSelectedPaymentMethod();
    }
  };
  this.buildWalletRequest = function () {
    return {
      customerId: _this.state.currentCustomerId
    };
  };
  this.selectPaymentMethod = function () {
    _this.actions.selectPaymentMethod(_this.currentlySelectedPaymentInstrument);
    _this.editAutoPayOnPaymentMethod();
  };
  this.getPaymentAmount = function (billPaymentOption) {
    var paymentAmount = null;
    switch (billPaymentOption) {
      case BILLPAY_OPTIONS.INSTALLMENT_TOTAL:
        paymentAmount = _this.state.promiseToPayDetails.InstallmentTotal;
        break;
      case BILLPAY_OPTIONS.TREATMENT_BALANCE:
        paymentAmount = _this.state.promiseToPayDetails.PromiseAmountRemaining;
        break;
      case BILLPAY_OPTIONS.STATEMENT_BALANCE:
        paymentAmount = _this.statementBalance;
        break;
      case BILLPAY_OPTIONS.ACCOUNT_TOTAL:
        paymentAmount = _this.state.currentPostPaidAccountSummary.PostpaidDetails.Total;
        break;
      case BILLPAY_OPTIONS.OTHER_AMOUNT:
        paymentAmount = parseFloat(_this.customPaymentAmount);
        break;
      case BILLPAY_OPTIONS.DEVICE_FINANCING:
        paymentAmount = pathOr(null, ['selectedDeviceFinancing', 'FinanceBalance'], _this.state);
        break;
      default:
        break;
    }
    return paymentAmount;
  };
  this.getPaymentCurrencyCode = function (billPaymentOption) {
    var currencyCode = null;
    if (billPaymentOption === BILLPAY_OPTIONS.INSTALLMENT_TOTAL || billPaymentOption === BILLPAY_OPTIONS.TREATMENT_BALANCE) {
      currencyCode = _this.state.promiseToPayDetails.CurrencyCode;
    } else if (billPaymentOption === BILLPAY_OPTIONS.STATEMENT_BALANCE || billPaymentOption === BILLPAY_OPTIONS.ACCOUNT_TOTAL) {
      currencyCode = _this.state.currentPostPaidAccountSummary.PostpaidDetails.CurrencyCode;
    } else {
      currencyCode = pathOr('USD', ['state', 'currentPostPaidAccountSummary', 'PostpaidDetails', 'CurrencyCode'], _this);
    }
    return currencyCode;
  };
  this.handleServiceError = function (errorMessageKey) {
    var serviceErrorAlert = i18n.translate(errorMessageKey);
    uiNotificationService.error(serviceErrorAlert, null, {
      timeOut: NOTIFICATION_TIME_LENGTH
    });
    if (_this.state.eWalletError && !_this.state.isCreatingOrEditingPaymentMethodData) {
      _this.mainFormServiceError = serviceErrorAlert;
    }
  };
  this.makePayment = function () {
    if (_this.isAutoPay || !_this.selectedAccount && !_this.deviceFinancingAccount || !_this.state.selectedPaymentMethod || _this.balanceIsInvalid()) {
      return;
    }

    //Determine if it's a device financing account
    var accountNumber = _this.deviceFinancingAccount ? _this.state.selectedDeviceFinancing.DeviceFinanceAccountNumber : _this.selectedAccount.AccountNumber;
    var request = {
      customerId: _this.state.currentCustomerId,
      request: {
        AccountNumber: accountNumber,
        InvoiceId: _this.selectedInvoiceId,
        Amount: _this.getPaymentAmount(_this.paymentAmountOption)
      }
    };
    if (!request.request.InvoiceId) {
      delete request.request.InvoiceId;
    }
    if (!pathOr(true, ['recordPayment'], _this.state.selectedPaymentMethod)) {
      request.request.PaymentInstruments = [_this.state.selectedPaymentClean];
    } else {
      request.request.PaymentInstrumentIds = [_this.state.selectedPaymentMethod.Id];
    }
    _this.mainFormServiceError = '';
    return _this.actions.chargePaymentInstrument(request).then(function () {
      _this.formApi.$setPristine();
      if (_this.state.isInTreatment) {
        _this.actions.retrieveConvergentBillerTreatmentDetails(_this.state.currentCustomerId).then(function () {
          _this.goBack();
        });
      } else {
        _this.goBack();
      }
    }).catch(function () {
      _this.handleServiceError(LocaleKeys.MAKE_PAYMENT.PAYMENT_FAILURE);
      _this.actions.resetIsMakingPayment();
    });
  };
  this.balanceIsInvalid = function () {
    return _this.paymentAmountOption === _this.billPayOptions.OTHER_AMOUNT && !_this.isValidPaymentAmount(_this.customPaymentAmount);
  };

  // Check to see if an amount is valid and greater than zero
  this.isValidPaymentAmount = function (amount) {
    return String(amount).trim().length > 0 && !isNaN(amount) && parseFloat(amount) > 0;
  };
  this.updateAutoPay = function () {
    if (!_this.isAutoPay || !_this.selectedAccount || !_this.state.selectedPaymentMethod || _this.hasNoPaymentInstruments()) {
      return;
    }
    var request = {
      updateAutoPay: true,
      customerId: _this.state.currentCustomerId,
      request: {
        PaymentInstrument: _this.state.selectedPaymentMethod
      }
    };
    _this.mainFormServiceError = '';
    return _this.actions.editPaymentInstrument(request).then(function () {
      uiNotificationService.success(i18n.translate(LocaleKeys.AUTO_PAY.SUCCESS), null, {
        timeOut: NOTIFICATION_TIME_LENGTH
      });
      _this.formApi.$setPristine();
      _this.goBack();
    }, function () {
      _this.handleServiceError(LocaleKeys.AUTO_PAY.FAILURE);
    });
  };
  this.goBack = function () {
    var route = _this.state.lastRoute.name || _this.DEFAULT_BACK_ROUTE;
    var params = _this.state.lastRoute.params || {};
    $state.go(route, params);
  };
  this.hasNoPaymentInstruments = function () {
    return _this.state.paymentInstruments.length === 0 && !_this.state.selectedPaymentMethod;
  };
  this.showPageLoader = function () {
    return _this.state.isFetchingEwalletData || _this.state.isMakingPayment || _this.state.isFetchingSubscriberSummary || _this.state.isUpdatingAutoPayData;
  };
  this.disableCustomPayment = function () {
    return _this.paymentAmountOption !== _this.billPayOptions.OTHER_AMOUNT;
  };
  this.getTitleKey = function () {
    return _this.isAutoPay ? LocaleKeys.AUTO_PAY.CONFIGURE_AUTO_PAY : LocaleKeys.MAKE_A_PAYMENT;
  };
  this.shouldDisableCurrentBalance = function () {
    return _this.state.totalBalance <= 0;
  };

  // If the amount to pay if zero, disable the option
  this.disablePaymentAmountOption = function (billPaymentOption) {
    if (!_this.isBalanceForward && billPaymentOption === BILLPAY_OPTIONS.ACCOUNT_TOTAL) {
      return true;
    }
    return _this.getPaymentAmount(billPaymentOption) <= 0;
  };
  this.canCreatePaymentInstruments = function () {
    if (!_this.state.currentHousehold) {
      return true;
    }
    return _this.state.currentMemberCanCreatePaymentInstrument;
  };
  this.onSubmit = function () {
    if (_this.isAutoPay) {
      _this.updateAutoPay();
    } else {
      _this.makePayment();
    }
  };
  this.findDeviceFinancingAccount = function () {
    var findDeviceIndex = function findDeviceIndex(device) {
      return device.DeviceFinanceAccountNumber === _this.deviceFinancingAccount;
    };
    return _this.state.subscriberFinancingDevices.findIndex(findDeviceIndex);
  };
  this.getDeviceFinancingDetails = function () {
    var deviceIndex = _this.findDeviceFinancingAccount();
    if (deviceIndex >= 0) {
      _this.actions.setDeviceFinancingWidgetSelectedDevice(deviceIndex);
      var deviceFinancingName = i18n.translate(_this.LocaleKeys.CUSTOMER_DASHBOARD.DEVICE_FINANCING_FOR, {
        deviceFinancingName: _this.state.deviceFinancingName
      });
      _this.deviceFinancingAccountDisplayName = "".concat(deviceFinancingName, " ").concat(deviceFinancingFriendlyName(_this.state.subscriberFinancingDevices[deviceIndex]));
    }
  };
  this.retrieveAllInvoices = function () {
    var request = {
      customerId: _this.state.currentCustomerId,
      request: {
        Filter: INVOICES
      }
    };
    _this.actions.retrieveLedgerSummary(request).then(function () {
      _this.formatInvoiceListForSelection();
    }).catch(function (error) {
      _this.uiNotificationService.transientError(error.translatedMessage);
    });
  };
  this.formatInvoiceListForSelection = function () {
    var clonedInvoiceList = clone(_this.state.invoiceList);
    var latestStatementsIndex = 0;
    var latestStatementsTime = null;
    _this.selectedOpenInvoice = null;
    clonedInvoiceList.forEach(function (item) {
      if (_this.state.routeParams.paymentType === MAKE_PAYMENT_TYPES.INVOICE) {
        _this.selectedOpenInvoice = item.InvoiceId === _this.state.routeParams.invoiceNumber ? item : _this.selectedOpenInvoice;
      } else {
        if (item.CurrentDue > 0) {
          latestStatementsTime = latestStatementsTime || item.IssueDate;
          if (latestStatementsTime < item.IssueDate) {
            latestStatementsIndex++;
            latestStatementsTime = item.IssueDate;
          }
          _this.formattedInvoiceList.push({
            currentDue: item.CurrentDue,
            dueDate: item.DueDate,
            invoiceId: item.InvoiceId,
            text: "".concat(item.InvoiceNumber, " - ").concat(_this.filter('invCurrency')(item.CurrentDue, item.CurrencyCode))
          });
        }
      }
    });
    if (_this.state.routeParams.paymentType !== MAKE_PAYMENT_TYPES.INVOICE) {
      if (_this.isBalanceForward) {
        _this.formattedInvoiceList.unshift({
          text: i18n.translate(_this.LocaleKeys.SEARCH_FIELDS_CUSTOMER.SINGLE_SELECT_PLACEHOLDER),
          invoiceId: null
        });
        _this.selectedInvoice = _this.formattedInvoiceList[0];
      }
      if (!_this.isBalanceForward && _this.formattedInvoiceList.length) {
        _this.selectedInvoice = _this.formattedInvoiceList[latestStatementsIndex];
        _this.getStatementBalanceFromCurrentInvoice(_this.formattedInvoiceList[latestStatementsIndex]);
      } else {
        _this.statementBalance = _this.state.currentPostPaidAccountSummary.PostpaidDetails.CurrentDue;
        _this.statementBalanceDueDate = _this.state.currentAccountSummary.PostpaidDetails.DueDate;
      }
    } else {
      _this.checkIfPaymentForOpenInvoiceDashboard();
    }
    _this.paymentAmountOption = _this.getDefaultPaymentAmountOption();
  };
  this.onInvoiceNumberSelected = function (selectedInvoiceNumber) {
    if (selectedInvoiceNumber.invoiceId) {
      _this.getStatementBalanceFromCurrentInvoice(selectedInvoiceNumber);
    }
  };
  this.getStatementBalanceFromCurrentInvoice = function (invoice) {
    _this.selectedInvoiceId = convertStringToNumber(invoice.invoiceId);
    _this.statementBalance = invoice.currentDue;
    _this.statementBalanceDueDate = invoice.dueDate;
    _this.paymentAmountOption = _this.getDefaultPaymentAmountOption();
  };
  this.checkIfPaymentForOpenInvoiceDashboard = function () {
    _this.selectedInvoiceId = convertStringToNumber(_this.selectedOpenInvoice.InvoiceId);
    _this.selectedOpenInvoiceNumber = _this.selectedOpenInvoice.InvoiceNumber;
    _this.statementBalance = _this.selectedOpenInvoice.CurrentDue;
    _this.statementBalanceDueDate = _this.selectedOpenInvoice.DueDate;
  };
}
export default {
  bindings: {
    isAutoPay: '<',
    deviceFinancingAccount: '<?'
  },
  template: require('./make.payment.html'),
  controller: CustomerMakePaymentController,
  controllerAs: 'CustomerMakePaymentController'
};